<!-- Used to create template of componenet -->
<template>
    <div :class="extraClass">
					<label
					class="np-label"
					:class="{ 'np-label--required': required, 'np-hide': hideLabel }"
					:for="name"
				>
					<slot name="label" scope="label">{{ label }}</slot>
				</label>
        <div style =
            "align-items: center;
            display: flex;">
            <div class="input-group-btn" v-show="!relative">
                <button class="np-button np-button--primary" type="button" @click="update_value(-step)">
									<FaIcon :icon="['fa', 'minus']"/>
                </button>
            </div>
            <input type="number"
							style="border-width: 1px; --border-opacity: 1; border-color: #CBD2D9; border-color: rgba(203, 210, 217, var(--border-opacity));"
							class="np-pl-2"
							:style="style"
							:id="id"
							:name="name"
							:class="defaultClass"
							:min="min"
							:max="max"
							:step="step"
							:relative="relative"
							v-model="ram_value"
							:required="required"
            />
            <div class="input-group-btn" v-show="!relative">
                <button class="np-button np-button--primary" type="button" @click="update_value(step)">
                    <FaIcon :icon="['fa', 'plus']"/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			form: {},
			ram_value: 0,
			defaultClass: 'form-control Adjust__input',
			style: '',
			extraClass: '',
		}
	},
	computed: {

	},
	// props are used for creating variables and their defualts
	props: {
		id: {
			type: [Number, String],
			default: '',
		},
		max: {
			type: Number,
			default: 100,
		},
		min: {
			type: Number,
			default: -100,
		},
		name: {
			type: String,
			default: '',
		},
		step: {
			type: Number,
			default: 1,
		},
		placeholder: {
			type: [Boolean, String],
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Number, String],
			default: 0,
		},
		relative: {
			type: Boolean,
			default: false,
		},
		hideLabel: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
	},
	// created is called before the component is created, though not necessarily when it's available on the page
	created() {
		if (!this.ram_value) {
			this.$emit('input', 0);
		}
		if (this.relative === true) {
			this.extraClass = '';
			this.defaultClass = 'form-control';
			this.style = '';
		}
	},
	// mounted is for when the values are avaliable on the page
	mounted() {
		this.ram_value = parseInt(this.value, 10);
	},
	// methods are used for functions
	methods: {
		update_value(step) {
			let updated = this.ram_value + step;
			if (updated > this.max) {
				updated = this.max;
			}
			if (updated < this.min) {
				updated = this.min;
			}
			this.ram_value = updated;
		},
	},
	watch: {
		ram_value() {
			if (this.ram_value > this.max) {
				this.ram_value = this.max;
			}
			if (this.ram_value < this.min) {
				this.ram_value = this.min;
			}
			if (!this.ram_value) {
				this.ram_value = 0;
			}
			this.$emit('input', this.ram_value);
		},
		value() {
			this.ram_value = parseInt(this.value, 10);
			this.$emit('input', this.ram_value);
		},
	},
};
</script>
<style lang="less">
    .Adjust__input {
    height: 40px !important;
    width: 100%;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}
</style>
